import { Link } from 'react-router-dom';
import { manhuaList, testimonials } from '@/mocks/manhua';

export default function LatestUpdates() {
  const latestManhua = [...manhuaList]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 6);

  return (
    <section className="bg-background-100 py-14 md:py-20" id="latest">
      <div className="px-4 md:px-8 lg:px-16">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-primary-500 inline-block"></span>
            <span className="text-xs font-medium text-primary-600 whitespace-nowrap">最新更新</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading leading-tight">
            每日更新，精彩不停
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            汇集全网最新最热的韩漫资源，每天都有新内容等你发现
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestManhua.map((manhua) => (
            <Link
              key={manhua.id}
              to={`/manhua/${manhua.id}`}
              className="bg-background-50 rounded-lg p-5 hover:bg-primary-50/50 transition-colors group"
            >
              <div className="flex gap-4">
                <div className="w-20 h-28 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={manhua.cover}
                    alt={manhua.altText}
                    title={manhua.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-0.5 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < Math.floor(manhua.rating) ? 'ri-star-fill text-accent-500' : 'ri-star-line text-secondary-300'}`}
                      ></i>
                    ))}
                    <span className="text-xs text-foreground-500 ml-1">{manhua.rating}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{manhua.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                    {manhua.description.slice(0, 60)}...
                  </p>
                  <div className="flex items-center gap-2 mt-3">
                    <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <span className="text-[10px] font-bold text-accent-700">{manhua.author.charAt(0)}</span>
                    </div>
                    <div className="min-w-0">
                      <p className="text-xs font-medium text-foreground-800 truncate">{manhua.author}</p>
                      <p className="text-[10px] text-foreground-400 whitespace-nowrap">{manhua.updatedAt}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-14">
          <div className="text-center mb-10">
            <div className="flex items-center justify-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full bg-accent-500 inline-block"></span>
              <span className="text-xs font-medium text-accent-600 whitespace-nowrap">读者心声</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading leading-tight">
              漫画爱好者的一致选择
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              听听真实读者对韩漫网的评价，为什么大家都爱在这里看漫画
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonials.map((t, idx) => (
              <div
                key={t.id}
                className={`bg-background-50 rounded-lg p-5 ${idx === 5 ? 'opacity-50' : ''}`}
              >
                <div className="flex gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-secondary-300'}`}
                    ></i>
                  ))}
                </div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-2">{t.title}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4">{t.comment}</p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div>
                    <p className="text-xs font-medium text-foreground-800">{t.name}</p>
                    <p className="text-[10px] text-foreground-400">{t.time}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}